/***
 * Базовый язык EN
***/
export const enToRu = {
    q: 'й', w: 'ц', e: 'у', r: 'к', t: 'е', y: 'н', u: 'г',
    i: 'ш', o: 'щ', p: 'з', '[': 'х', ']': 'ъ',
    a: 'ф', s: 'ы', d: 'в', f: 'а', g: 'п', h: 'р',
    j: 'о', k: 'л', l: 'д', ';': 'ж', "'": 'э',
    z: 'я', x: 'ч', c: 'с', v: 'м', b: 'и',
    n: 'т', m: 'ь', ',': 'б', '.': 'ю'
};

export const enToEs = {
    q: 'q', w: 'w', e: 'e', r: 'r', t: 't', y: 'y', u: 'u',
    i: 'i', o: 'o', p: 'p', '[': '`', ']': '+',
    a: 'a', s: 's', d: 'd', f: 'f', g: 'g', h: 'h',
    j: 'j', k: 'k', l: 'l', ';': 'ñ', "'": '´',
    z: 'z', x: 'x', c: 'c', v: 'v', b: 'b',
    n: 'n', m: 'm', ',': ',', '.': '.'
};
export const enToFr = {
    q: 'a', w: 'z', e: 'e', r: 'r', t: 't', y: 'y', u: 'u',
    i: 'i', o: 'o', p: 'p', '[': '^', ']': '$',
    a: 'q', s: 's', d: 'd', f: 'f', g: 'g', h: 'h',
    j: 'j', k: 'k', l: 'l', ';': 'm', "'": 'ù',
    z: 'w', x: 'x', c: 'c', v: 'v', b: 'b',
    n: 'n', m: ',', ',': ';', '.': ':'
};
export const enToDe = {
    q: 'q', w: 'w', e: 'e', r: 'r', t: 't', y: 'z', u: 'u',
    i: 'i', o: 'o', p: 'p', '[': 'ü', ']': '+',
    a: 'a', s: 's', d: 'd', f: 'f', g: 'g', h: 'h',
    j: 'j', k: 'k', l: 'l', ';': 'ö', "'": 'ä',
    z: 'y', x: 'x', c: 'c', v: 'v', b: 'b',
    n: 'n', m: 'm', ',': ',', '.': '.'
};
export const enToKz = {
    q: 'й', w: 'ц', e: 'у', r: 'к', t: 'е', y: 'н', u: 'г',
    i: 'ш', o: 'щ', p: 'з', '[': 'х', ']': 'ъ',
    a: 'ф', s: 'ы', d: 'в', f: 'а', g: 'п', h: 'р',
    j: 'о', k: 'л', l: 'д', ';': 'ж', "'": 'э',
    z: 'я', x: 'ч', c: 'с', v: 'м', b: 'и',
    n: 'т', m: 'ь', ',': 'б', '.': 'ю',
    '`': 'ё',
    '\\': 'ә',
};
export const detectedRegex = {
    ru: /[а-яё]/i,
    en: /[a-z]/i,
    de: /[a-zäöüß]/i,
    es: /[a-zñ]/i,
    kz: /[а-яёәіңғүұқөһ]/i
};